<template>
	<Col class="width-100 height-100 flex-centerize">
		<AppLoader v-if="isLoading" />
		<iframe v-show="!isLoading" class="width-100 height-100" @load="isLoading = false" src="https://videos.ply.io/watch/gallery/Mzc5MA" />
	</Col>
</template>

<script>
export default {
	name: 'Learn',
	data() {
		return { isLoading: true };
	},
};
</script>

<style scoped lang="scss"></style>
